/**
 * Claves de localStorage usadas en la aplicación.
 * Centralizadas para evitar typos y tener una única fuente de verdad.
 */
const STORAGE_KEYS = {
  USER: 'user',
  STUDENT: 'student',
  ENROLLMENT: 'enrollment',
  LAST_PATH: 'lastPath',
  LAST_UPDATE: 'lastUpdate',
};

export default STORAGE_KEYS;
